// extracted by mini-css-extract-plugin
module.exports = {"logoNormal":"dfa_logoNormal__10oAL","logo":"dfa_logo__3044i"};